import styled from '@emotion/styled';

import { breakpoints } from 'styles/basic';

const Wrapper = styled.div`
  max-width: ${(props) => props.theme.layout.width};
  margin: 0 auto;
  padding: 0 ${(props) => props.theme.layout.mobilePadding};

  @media (min-width: ${breakpoints.smallTablet}) {
    padding-right: ${(props) => props.theme.layout.padding};
    padding-left: ${(props) => props.theme.layout.padding};
  }
`;

export {
  Wrapper
};
